<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label for="label">{{ 'layout.configurations.technologies.label' | translate }}</label>
    <input id="label" formControlName="label" type="text" pInputText
      [placeholder]="'layout.configurations.technologies.label' | translate" class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('label') }" />
    <div class="text-red-600" *ngIf="form.get('label')?.invalid && (form.get('label')?.touched || form.get('label')?.dirty)">
      <div *ngIf="form.get('label')?.hasError('required')">
        {{ 'layout.configurations.technologies.addTechnology.nameIsRequired' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('multipleSpaces')">
        {{ 'layout.configurations.technologies.addTechnology.multipleSpaces' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('missingLetter')">
        {{ 'layout.configurations.technologies.addTechnology.missingLetter' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('invalidCharacters')">
        {{ 'layout.configurations.technologies.addTechnology.invalidCharacters' | translate }}
      </div>
    </div>
    <div *ngIf="formErrors" class="text-red-600">
      {{ getErrorMessage('label') | translate }}
    </div>
    <div *ngIf="formErrors" class="text-red-600">{{ getErrorMessage('label') | translate }}</div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check"
      [label]="'layout.configurations.technologies.addTechnology.save' | translate"></p-button>
  </div>
</form>